/*
 * Copyright 2018 American Express
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

import hash from 'object-hash';

import config from '../config';

export function getStateBranch(stateOrGetState) {
  if (typeof stateOrGetState === 'function') {
    return config.getToState(stateOrGetState());
  }
  return config.getToState(stateOrGetState);
}

export function getStateOfQuery({ endpointName, query, variables }) {
  const queryHash = hash(query);
  const variablesHash = hash(variables);
  return state => getStateBranch(state).getIn(['endpoints', endpointName, 'queries', queryHash, 'variables', variablesHash]);
}
